'use client';

export const textLang: any = {
    us: {
        line1: 'By submitting your information above, you agree to EcoFlow’s',
        line2: ' Privacy Policy.',
    },
};
